/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { Work } from './Work';
const CloneResultParser = /* #__PURE__ */ parsers.object([
    ['work', Work],
]);
export class CloneResult extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CloneResultParser.decode(input).map(res => new CloneResult(res));
    }
    static unsafeDecode(input) {
        return CloneResult.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CloneResultParser.encode(data);
    }
    static schema() {
        return CloneResultParser.schema();
    }
}
